module.exports = __webpack_public_path__ + "a7dcf7c1e816f25e02900a45faf45419.webp";